import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Table,
    TableBody,
    TableContainer,
    TableRow,
    TableHead,
    Paper,
    TableCell,
    Alert,
    Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getApplicationType } from '../../../../../../actions/rof-burns/rof-actions';

const APPLICATION_TABLE_HEADERS = [
    'On-Site vs Off Site',
    'Application Type',
    'Application From',
    'Location',
    'Kiln Used',
    'Created At',
]

export default function RofApplication({ projectKey }) {
    const dispatch = useDispatch();
    const [hideState, setHideState] = useState({});
    const applicationTypes = useSelector((state) => (state.rofBurnsReducer.applicationTypes))

    const toggleHide = (applicationId) => {
        setHideState(prevState => ({
            ...prevState,
            [applicationId]: !prevState[applicationId]
        }));
    };

    useEffect(() => {
        dispatch(getApplicationType(projectKey));
    }, [dispatch, projectKey]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant='h5'>Biochar Application Data</Typography>
            <Box>
                {!applicationTypes || applicationTypes?.data?.length === 0
                    ? <Alert severity="info" sx={{ width: 'fit-content' }}>
                        No Biochar Application Data available for this project
                    </Alert>
                    : applicationTypes?.data?.map((application, index) => (
                        <Accordion key={index}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index}-content`}
                                id={`panel${index}-header`}
                                onClick={() => toggleHide(`Application-${index}`)}
                            >
                                <Typography>
                                    {hideState[`Application-${index}`] ? "Hide" : "Expand"} {application.batchId}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TableContainer component={Paper} sx={{ height: 'auto' }}>
                                    <Table aria-label="application data table">
                                        <TableHead>
                                            <TableRow>
                                                {APPLICATION_TABLE_HEADERS.map((header) => (
                                                    <TableCell
                                                        key={header}
                                                        align='left'
                                                    >
                                                        {header}
                                                    </TableCell>
                                                ))
                                                }
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell align="left">{application.onSiteVsOffSite || "N/A"}</TableCell>
                                                <TableCell align="left">{application.applicationType || "N/A"}</TableCell>
                                                <TableCell align="left">{application.applicationFrom || "N/A"}</TableCell>
                                                <TableCell align="left">
                                                    {application.latitude && application.longitude
                                                        ? `${application.latitude}, ${application.longitude}`
                                                        : "N/A"}
                                                </TableCell>
                                                <TableCell align="left">{application.kilnUsed || "N/A"}</TableCell>
                                                <TableCell align="left">{new Date(application.createdAt).toLocaleString()}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </AccordionDetails>
                        </Accordion>
                    ))
                }
            </Box>
        </Box>
    );
}